import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services/api'

export const fetchAuditLogs = createAsyncThunk('audit/fetchLogs',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await api.get('/api/v1/audit-logs', { params }).then(r => r.data)
    } catch (err) {
      return rejectWithValue(err.response?.data?.detail || 'Failed to load audit logs')
    }
  }
)

const auditSlice = createSlice({
  name: 'audit',
  initialState: {
    entries: [],
    logs:    [],
    total:   0,
    loading: false,
    errors:  {},
    filters: {
      subject:  '',
      action:   '',
      actor:    '',
      search:   '',
      dateFrom: '',
      dateTo:   '',
    },
  },

  reducers: {
    addAuditLog(state, { payload }) {
      const entry = {
        id:         `aud_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
        timestamp:  new Date().toISOString(),
        action:     payload.action,
        subject:    payload.subject,
        meta:       payload.meta      || {},
        userId:     payload.userId    || null,
        userName:   payload.userName  || null,
        userRole:   payload.userRole  || null,
        actorName:  payload.userName  || 'Current User',
        actorEmail: payload.userEmail || '',
        actorRole:  payload.userRole  || '',
        ipAddress:  'localhost',
        createdAt:  new Date().toISOString(),
        local:      true,
      }
      state.entries = [entry, ...state.entries].slice(0, 500)
    },

    clearAuditLog(state) {
      state.entries = []
    },

    setAuditFilter(state, { payload }) {
      state.filters = { ...state.filters, ...payload }
    },

    resetAuditFilters(state) {
      state.filters = { subject: '', action: '', actor: '', search: '', dateFrom: '', dateTo: '' }
    },
  },

  extraReducers: (b) => {
    b.addCase(fetchAuditLogs.pending, (state) => {
      state.loading = true
      state.error   = null
    })
    b.addCase(fetchAuditLogs.fulfilled, (state, action) => {
    
      state.loading = false
      state.logs    = action.payload.data  || []
      state.total   = action.payload.total || 0
    })
    b.addCase(fetchAuditLogs.rejected, (state, action) => {
      state.loading = false
      state.error   = action.payload || 'Failed to load audit logs'
      state.logs    = []   // clear stale mock data
    })
  },
})

export const {
  addAuditLog, clearAuditLog,
  setAuditFilter, resetAuditFilters,
} = auditSlice.actions

export const selectAuditEntries = s => s.audit.entries
export const selectAuditBuffer  = s => s.audit.entries
export const selectAuditLogs    = s => s.audit.logs
export const selectAuditLoading = s => s.audit.loading
export const selectAuditFilters = s => s.audit.filters
export const selectAuditTotal   = s => s.audit.total

export default auditSlice.reducer

export const auditMiddleware = (store) => (next) => (action) => {
  if (action.type === 'audit/addAuditLog') {
    const { auth } = store.getState()
    if (auth?.user && !action.payload.userId) {
      action.payload.userId    = auth.user.id
      action.payload.userName  = auth.user.name || auth.user.email
      action.payload.userEmail = auth.user.email
      action.payload.userRole  = auth.user.role
    }
  }
  return next(action)
}